import type { Client, SavedLocation } from '@hero/schema';
import { useSavedLocationListApi } from '@hero/api-hooks';
import { useTranslation } from 'react-i18next';
import { SharedList } from '../../../app/List/List';
import { SavedLocationCard } from '../../SavedLocation/Card/SavedLocationCard';

export interface ClientLocationsTabProps {
  client: Client;
}

export function ClientLocationsTab({ client }: ClientLocationsTabProps) {
  const { t } = useTranslation(['m-client']);

  const locationsQuery = useSavedLocationListApi({ clientId: client._id });

  return (
    <div className="px-5 py-2">
      <SharedList<SavedLocation>
        query={locationsQuery}
        emptyMessage={t('drawer.no_locations')}
        className="gap-2"
        renderItem={location => <SavedLocationCard savedLocation={location} />}
      />
    </div>
  );
}
